import { render, staticRenderFns } from "./news_modal_event_reg.vue?vue&type=template&id=b41e190e"
import script from "./news_modal_event_reg.vue?vue&type=script&lang=js"
export * from "./news_modal_event_reg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports